export default __webpack_public_path__ + "static/media/bobo-collect-list.f477ea53.png";